import useSentinelTeam from 'hooks/useSentinelTeam';

export default function useAlertsConfiguration() {
  const { alertConfiguration } = useSentinelTeam();

  const scheduledMaintenanceConfiguration = alertConfiguration?.find(
    ({ id }) => id === 'ScheduledMaintenance',
  );

  const scheduledMaintenanceEnabled =
    !!scheduledMaintenanceConfiguration?.enabled;

  const scheduleMaintenanceSeveritiesEnabled =
    scheduledMaintenanceConfiguration?.severity;

  const faultsConfiguration = alertConfiguration?.find(
    ({ id }) => id === 'Fault',
  );

  const faultsEnabled = !!faultsConfiguration?.enabled;

  const faultSeveritiesEnabled = faultsConfiguration?.severity;

  const customAlertsConfigurations = alertConfiguration?.filter(
    ({ __typename }) => __typename === 'CustomAlertConfig',
  );

  const enabledCustomAlerts = customAlertsConfigurations?.filter(
    ({ enabled }) => enabled,
  );

  return {
    faultsEnabled,
    faultSeveritiesEnabled,
    faultsConfiguration,
    enabledCustomAlerts,
    customAlertsConfigurations,
    scheduledMaintenanceEnabled,
    scheduledMaintenanceConfiguration,
    scheduleMaintenanceSeveritiesEnabled,
  };
}
